import GetQueryParam from '../util/get-query-param';
import { setTwentyTwenty } from '../util/twenty-twenty';

class WellnessController {
    constructor() {

        this.players = {};
        this.playerReady = {};
        this.setOwnersVoiceSlider();
        this.setOtherSlider2();
        this.setInterviewSlide();
        this.loadYouTubeAPI();
        this.setImageCompare();

        let q = new GetQueryParam();

        if (q.movie) {
            setTimeout(() => {
                $('#js-style-detail__movie-btn').trigger('click');
            }, 2500);
        }
    }
    loadYouTubeAPI() {
        if (!window.YT) {
            let tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            let firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this);
        } else {
            this.onYouTubeIframeAPIReady();
        }
    }
    onYouTubeIframeAPIReady() {
        this.createPlayer('js-popup__movie', 'js-style-detail__movie-btn');
        this.createPlayer('js-popup__movie2', 'js-style-detail__movie-btn2');
        this.setPopupMovies();
    }

    createPlayer(playerId, buttonId) {
        this.players[playerId] = new YT.Player(playerId, {
            videoId: $(`#${ buttonId }`).data('yid'),
            events: {
                'onReady': (event) => {
                    this.playerReady[playerId] = true;
                }
            }
        });
    }

    setPopupMovies() {
        this.setPopupMovie('js-style-detail__movie-btn', 'style-detail__movie-popup', 'js-popup__movie');
        this.setPopupMovie('js-style-detail__movie-btn2', 'style-detail__movie-popup2', 'js-popup__movie2');
    }

    setPopupMovie(buttonId, popupClass, playerId) {
        let $link = $(`#${ buttonId }`);
        let $pop = $(`.${ popupClass }`);
        let _this = this;

        $link.on('click', function (e) {
            e.preventDefault();
            $pop.addClass('is-open');
            if (_this.playerReady[playerId]) {
                _this.players[playerId].playVideo();
            } else {
                console.warn(`Player ${ playerId } is not ready yet.`);
            }
        });

        $pop.on('click', function (e) {
            e.preventDefault();
            if ($(e.target).hasClass('is-open')) {
                $pop.removeClass('is-open');
                if (_this.playerReady[playerId]) {
                    _this.players[playerId].pauseVideo();
                }
            }
        });

        $pop.find('.common-popup__close').on('click', function (e) {
            e.preventDefault();
            $pop.removeClass('is-open');
            if (_this.playerReady[playerId]) {
                _this.players[playerId].pauseVideo();
            }
        });
    }


    setOwnersVoiceSlider() {
        let slideCount = document.querySelectorAll('#js-ownersvoice-slide .swiper-slide').length;
        if (window.UA.isSP) {
            // スマホ幅のとき
            if (slideCount >= 2) {
                let options = {
                    loop: false,
                    loopAdditionalSlides: 1,
                    loopFillGroupWithBlank: false,
                    centeredSlides: false,
                    spaceBetween: 24,
                    slidesPerView: 'auto',
                    navigation: {
                        nextEl: '#js-ownersvoice-next',
                        prevEl: '#js-ownersvoice-prev',
                    },
                    scrollbar: {
                        el: '#js-ownersvoice-bar',
                        draggable: false,
                    },
                    touchAngle: 20,
                    speed: 800,
                };
                let otherSlider = new Swiper('#js-ownersvoice-slide', options);
                otherSlider.off('resize');
            } else {
                document.querySelector('#js-ownersvoice-slide').classList.add('min-slide');
                document.querySelector('#js-ownersvoice-nav').classList.add('min-slide-nav');
            }
        } else {
            // PC幅のとき
            if (slideCount >= 4) {
                let options = {
                    loop: false,
                    loopAdditionalSlides: 1,
                    loopFillGroupWithBlank: false,
                    centeredSlides: false,
                    spaceBetween: 32,
                    slidesPerView: 'auto',
                    navigation: {
                        nextEl: '#js-ownersvoice-next',
                        prevEl: '#js-ownersvoice-prev',
                    },
                    scrollbar: {
                        el: '#js-ownersvoice-bar',
                        draggable: false,
                    },
                    touchAngle: 20,
                    speed: 800,
                };
                let otherSlider = new Swiper('#js-ownersvoice-slide', options);
            } else {
                document.querySelector('#js-ownersvoice-slide').classList.add('min-slide');
                document.querySelector('#js-ownersvoice-nav').classList.add('min-slide-nav');
            }
        }
    }
    setOtherSlider2() {
        let options = {
            loop: false,
            spaceBetween: (window.UA.isSP) ? 24 : 32,
            slidesPerView: 'auto',
            navigation: {
                nextEl: '#style-detail__other-slide-next2',
                prevEl: '#style-detail__other-slide-prev2',
            },
            scrollbar: {
                el: '#style-detail__other-slide-bar2',
                draggable: false,
            },
            touchAngle: 20,
            speed: 800,
            lazy: {
                loadPrevNext: true,
            },
        };

        let otherSlider = new Swiper('#js-style-detail__other-slide2', options);
        otherSlider.update();
    }

    setInterviewSlide() {
        let options = {
            loop: false,
            loopAdditionalSlides: 1,
            loopFillGroupWithBlank: false,
            centeredSlides: false,
            spaceBetween: (window.UA.isSP) ? 24 : 32,
            slidesPerView: 'auto',
            navigation: {
                nextEl: '#style-detail__other-slide-next',
                prevEl: '#style-detail__other-slide-prev',
            },
            scrollbar: {
                el: '#style-detail__other-slide-bar',
                draggable: false,
            },
            touchAngle: 20,
            speed: 800,
            on: {
                // onSlideChangeEnd : (s) => {s.fixLoop();}
            },
        };

        let otherSlider = new Swiper('#js-home-interview-slide', options);
        if (window.UA.isSP) {
            otherSlider.off('resize');
        }
        $('#style-detail__other-slide-next').on('click', () => {
            // console.log(voiceSlider.isEnd);
            // if (otherSlider.isEnd === true) {
            //     otherSlider.slideTo(0);
            // }
        });
    }

    setImageCompare() {

        setTwentyTwenty();

        $(document).ready(function() {
            $(".twentytwenty-container").twentytwenty();
        });
        $(document).ready(function() {
            $(".twentytwenty-containerSP").twentytwenty();
        });
    }
}

export default WellnessController;
